import React,{useState} from 'react'
import barcodeServices from '../services/barcodeServices';
import { Dialog, DialogActions, DialogContent } from '@mui/material';

function GenerateBarcode({callback}) {
    const [count,setCount] = useState("");
    const [dialogStatus, setDialogStatus] = useState(false);

    const generateBarcode = () =>{
        barcodeServices.generateBarcode({count:count}).then(res=>{
            setDialogStatus(false)
            callback();
            console.log(res.data);
        }).catch(error=>{
            console.log(error)
        })
    }

    return (
        <>
            <button className='btn btn-primary' onClick={()=>setDialogStatus(true)} >Generate New Batch</button>
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}
                fullWidth={true}
                maxWidth="md"
            >
                <DialogContent>
                    <div className='row mt-2'>
                        <div className='col-md-12'>
                            <form className="form-floating">
                                <input type="number" className="form-control" value={count} onChange={(e)=>setCount(e.target.value)} />
                                <label>Qty</label>
                            </form>
                        </div>
                    </div>
                </DialogContent>
                 <DialogActions>
                    <button className="btn btn-outline-primary" onClick={generateBarcode} >Generate</button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default GenerateBarcode